var cleanGameTypeIdFromQuery = function (url) {
    if (url === void 0) { url = ''; }
    return url.replace(/&gameTypeId=\d{0,}/i, '');
};

export { cleanGameTypeIdFromQuery };
